import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Box, Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import { useAppMeta, useAuth } from "hooks";
import {
  useGetAccountLedgerDetailQuery,
  useUpdateAccountLedgerMutation,
} from "store/services/accountLedgerApi";
import {
  AccountLedgerDetailContext,
  useAccountLedgerDetailContext,
} from "contexts/PaymentContexts/AccountLedgerContext";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { BASE_CONSTANTS } from "constants/baseConstants";
import EnableDisableButton from "components/Shared/EnableDisableButton";
import AccountLedgerBasicDetail from "./AccountLedgerBasicDetail";

const breadcrumbs = [
  { title: "Account Ledger ", path: "/app/crm/account-ledger/list" },
  { title: "Account Ledger Detail" },
];

const AccountLedgerDetailScreen = () => {
  const { id } = useParams();

  const {
    data: accountLedgerDetail,
    isLoading: accountLedgerLoading,
    isFetching: accountLedgerFetching,
  } = useGetAccountLedgerDetailQuery(id);

  useAppMeta("Account Ledger Detail");

  return (
    <AccountLedgerDetailContext.Provider value={{ accountLedgerDetail }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={accountLedgerLoading || accountLedgerFetching}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Paper>
          <AccountLedgerBasicDetail
            accountLedgerDetail={accountLedgerDetail}
            loadingAccountLedger={accountLedgerLoading || accountLedgerFetching}
          />
          <Divider />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </AccountLedgerDetailContext.Provider>
  );
};

const PageActions = () => {

  const { isAccountAdmin } = useAuth();

  const { accountLedgerDetail } = useAccountLedgerDetailContext();

  // RTK Query
  const [updateAccountLedger, { isLoading: updatingAccountLedger }] =
    useUpdateAccountLedgerMutation();

  // methods
  const handleUpdateAccountLedgerStatus = async () => {
    try {
      await updateAccountLedger({
        _id: accountLedgerDetail?._id,
        status:
          accountLedgerDetail?.status === "Active" ? "Inactive" : "Active",
      }).unwrap();
      toast.info(
        `Account Ledger successfully ${
          accountLedgerDetail?.isActive ? "Disabled" : "Enabled"
        }!`
      );
    } catch (err) {
      toast.error(
        err?.data?.message ?? "Couldn't update Account Ledger Status!"
      );
    }
  };

  return (
    <Box display="flex" gap={BASE_CONSTANTS.SPACING_SM}>
      {isAccountAdmin &&(
        <EnableDisableButton
          suffix="AccountLedger"
          isActive={accountLedgerDetail?.status === "Active" ? true : false}
          loading={updatingAccountLedger}
          onClick={handleUpdateAccountLedgerStatus}
        />
      )}

      <Link to={`/app/crm/account-ledger/${accountLedgerDetail?._id}/edit`}>
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      </Link>
    </Box>
  );
};

export default AccountLedgerDetailScreen;
